/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useEffect } from 'react';
import ReactModal from 'react-modal';

const setupAccessibility = (setModalAccessibilityElement: (appElement: HTMLElement) => void, queryElement: string) => {
  const appContent = document.querySelector(queryElement);
  if (!appContent) {
    // TODO: Add Error Handling
  } else {
    setModalAccessibilityElement(appContent as HTMLElement);
  }
};

export const AccessibilityListeners: React.FC<{}> = ({}) => {
  useEffect(() => {
    setupAccessibility(ReactModal.setAppElement, '#root');
  }, []);
  return null;
};
